<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerText]="(T.CONFIGURATION_EDITOR_CAMERA_RESOLUTION_DIALOG_TITLE | translate) + data.camera.ipAddress + '  ' + data.camera.name"
	[headerIcon]="{fontIcon: 'fa-camera-home', fontSet: 'fad'}"
	[matDialogData]="data"
	[rect]="rect"
	[smallHeader]="true"
>
	<div dialogContent>
		@if (data?.camera) {
			<div>
				<div style="margin-bottom: 10px">
					<strong>{{ supportedResolutionsText }}</strong>
				</div>
				<form [formGroup]="form">
					<div class="example-container mat-elevation-z8" formArrayName="camerasArray">
						<table [dataSource]="form.controls.camerasArray.controls" mat-table style="width: 100%">
							<ng-container matColumnDef="resolutionType">
								<th *matHeaderCellDef mat-header-cell>
									{{ T.CONFIGURATION_EDITOR_CAMERA_RESOLUTION_TYPE | translate }}
								</th>
								<td
									*appMatCellDef="let element; dataSource: form.controls.camerasArray.controls"
									mat-cell
									style="padding-left: 10px"
								>
									<ng-container>
										{{ CameraResolutionType[element.controls.type.value] }}
									</ng-container>
								</td>
							</ng-container>
							<ng-container matColumnDef="outputFormat">
								<th *matHeaderCellDef mat-header-cell>
									{{ T.CONFIGURATION_EDITOR_CAMERA_OUTPUT_FORMAT | translate }}
									<span (click)="updateAllValue('OutputFormat')">
										<i class="fad fa-edit" style="color: rgb(39 153 137)"></i
									></span>
								</th>
								<td *appMatCellDef="let element; let i = index; dataSource: form.controls.camerasArray.controls" mat-cell>
									<mat-form-field color="accent">
										<mat-select
											[(ngModel)]="data.camera.configuration.resolutions[i].outputFormat"
											[ngModelOptions]="{standalone: true}"
										>
											@for (cameraDestinationFormat of cameraDestinationFormats; track cameraDestinationFormat) {
												<mat-option [value]="cameraDestinationFormat.value">
													{{ cameraDestinationFormat.name }}
												</mat-option>
											}
										</mat-select>
									</mat-form-field>
								</td>
							</ng-container>
							<ng-container matColumnDef="width">
								<th *matHeaderCellDef mat-header-cell>
									{{ T.CONFIGURATION_EDITOR_CAMERA_WIDTH | translate }}
								</th>
								<td *appMatCellDef="let element; let i = index; dataSource: form.controls.camerasArray.controls" mat-cell>
									<mat-form-field color="accent" class="resolutionsWidth">
										<input
											[(ngModel)]="data.camera.configuration.resolutions[i].width"
											[ngModelOptions]="{standalone: true}"
											matInput
											name="width"
											type="number"
										/>
									</mat-form-field>
								</td>
							</ng-container>
							<ng-container matColumnDef="height">
								<th *matHeaderCellDef mat-header-cell>
									{{ T.CONFIGURATION_EDITOR_CAMERA_HEIGHT | translate }}
								</th>
								<td *appMatCellDef="let element; let i = index; dataSource: form.controls.camerasArray.controls" mat-cell>
									<mat-form-field color="accent" class="resolutionsWidth">
										<input
											[(ngModel)]="data.camera.configuration.resolutions[i].height"
											[ngModelOptions]="{standalone: true}"
											matInput
											name="height"
											type="number"
										/>
									</mat-form-field>
								</td>
							</ng-container>
							<ng-container matColumnDef="framerate">
								<th *matHeaderCellDef mat-header-cell>
									{{ T.CONFIGURATION_EDITOR_CAMERA_FRAMERATE | translate }}
									<span (click)="updateAllValue('Framerate')">
										<i class="fad fa-edit" style="color: rgb(39 153 137)"></i
									></span>
								</th>
								<td *appMatCellDef="let element; let i = index; dataSource: form.controls.camerasArray.controls" mat-cell>
									<mat-form-field color="accent" class="resolutionsWidth">
										<input
											[(ngModel)]="data.camera.configuration.resolutions[i].framerate"
											[max]="60"
											[min]="0"
											[ngModelOptions]="{standalone: true}"
											matInput
											name="framerate"
											type="number"
										/>
									</mat-form-field>
								</td>
							</ng-container>
							<ng-container matColumnDef="compression">
								<th *matHeaderCellDef mat-header-cell>
									{{ T.CONFIGURATION_EDITOR_CAMERA_COMPRESSION | translate }}
									<span (click)="updateAllValue('Compression')">
										<i class="fad fa-edit" style="color: rgb(39 153 137)"></i
									></span>
								</th>
								<td *appMatCellDef="let element; let i = index; dataSource: form.controls.camerasArray.controls" mat-cell>
									<mat-form-field color="accent" class="resolutionsWidth">
										<input
											[(ngModel)]="data.camera.configuration.resolutions[i].compression"
											[max]="100"
											[min]="0"
											[ngModelOptions]="{standalone: true}"
											matInput
											name="compression"
											type="number"
										/>
									</mat-form-field>
								</td>
							</ng-container>
							<ng-container matColumnDef="useProxy">
								<th *matHeaderCellDef mat-header-cell>
									{{ T.CONFIGURATION_EDITOR_CAMERA_USE_PROXY | translate }}
								</th>
								<td
									*appMatCellDef="let element; let i = index; dataSource: form.controls.camerasArray.controls"
									mat-cell
									style="text-align: center"
								>
									<mat-checkbox
										[(ngModel)]="data.camera.configuration.resolutions[i].useCameraProxy"
										[ngModelOptions]="{standalone: true}"
										value="proxy"
									/>
								</td>
							</ng-container>
							<tr *matHeaderRowDef="columnsToDisplay; sticky: true" mat-header-row></tr>
							<tr
								*matRowDef="let row; let i = index; columns: columnsToDisplay"
								[ngClass]="{
									danger:
										supportedResolutionsValidation.indexOf(
											'|' +
												data.camera.configuration.resolutions[i].width +
												'x' +
												data.camera.configuration.resolutions[i].height +
												'|'
										) < 0,
									success:
										supportedResolutionsValidation.indexOf(
											'|' +
												data.camera.configuration.resolutions[i].width +
												'x' +
												data.camera.configuration.resolutions[i].height +
												'|'
										) >= 0,
								}"
								mat-row
							></tr>
						</table>
					</div>
				</form>
			</div>
		}
	</div>

	<ng-container actions>
		<button (click)="updateAllCamerasOfType()" [attr.title]="cameraType" class="large" color="accent" mat-raised-button>
			{{ T.CONFIGURATION_EDITOR_CAMERA_USE_RESOLUTIONS_FOR_ALL_CAMERAS_OF_TYPE | translate: {type: cameraType || ""} }}
		</button>

		<button (click)="updateAllCameras()" color="accent" mat-raised-button class="large">
			{{ T.CONFIGURATION_EDITOR_CAMERA_USE_RESOLUTIONS_FOR_ALL_CAMERAS | translate }}
		</button>

		<sim-button
			(onClick)="close({action: 'close'})"
			[icon]="{fontSet: 'fal', fontIcon: 'fa-times'}"
			[label]="T.BUTTON_CANCEL"
			[color]="'warn'"
		/>

		<sim-button
			(onClick)="ok()"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.CONFIGURATION_EDITOR_CAMERA_OK"
			[color]="'accent'"
		/>
	</ng-container>
</sim-basic-material-dialog>
